export default __webpack_public_path__ + "static/media/bila-sesit.c6533c61.svg";